<template>
  <div v-if="value.length > 0">
    <template
      v-for="(schedule, i__) in value"
    >
      <Schedule
        :value="schedule"
        :index="i__"
        :key="i__"
        @view="$emit('view', schedule)"
        @edit="$emit('edit', schedule)"
      />
    </template>
  </div>
</template>

<script>
import Schedule from './Schedule'

export default {
  components: { Schedule },
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
</script>
